// This function is used to find the color separator for the main event
export const colorsSeparator = Object.freeze({
  'basel': 'basel',
  'miami-beach': 'miami',
  'hong-kong': 'hongkong',
  'cities': 'cities',
  'paris': 'paris',
  'qatar': 'qatar'
})

export default colorsSeparator
